import BaseComponent from "../../../../baseComponent";
import InternalEvent from "../../../../../core/constants/internalEvent";
import styles from "./timeSeriesChartConfiguration.scss";
import WidgetService from "../../../../../core/services/widgetService";
import WidgetType from "../../../../../core/constants/widgetType";

import CheckBox from "../../../../common/check-box/checkBox.jsx";
import Modal from "../../../../common/modal.jsx";

export default class TimeSeriesChartConfiguration extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getStateObject(props.widget);
  }

  getStateObject(widget) {
    const {
      timeTickFormat, ticks, alignLegend, yTickOption, yTickOptionValue,
      timeAdjustmentOption, timeAdjustmentOptionValue, yAxisVisibility, updateInterval,
      maxRepeatDuration
    } = widget.metaData;
    return {
      format: timeTickFormat || "MMM D YYYY HH:mm:ss",
      margins: this.getInitialMargin(widget),
      ticks: ticks || "auto",
      alignLegend: alignLegend || false,
      yTickOption: yTickOption ? yTickOption : "increment",
      yTickOptionValue: yTickOptionValue ? yTickOptionValue : "",
      timeAdjustmentOption: timeAdjustmentOption ? timeAdjustmentOption : "d",
      timeAdjustmentOptionValue: timeAdjustmentOptionValue ? timeAdjustmentOptionValue : "",
      yAxisVisibility: yAxisVisibility ? yAxisVisibility : "all",
      updateInterval: updateInterval ? updateInterval : 0,
      maxRepeatDuration: maxRepeatDuration ? maxRepeatDuration : 0
    };
  }

  componentWillReceiveProps(nextProps) {
    const newState = this.getStateObject(nextProps.widget);
    this.setState(newState);
  }

  componentDidMount() {
    $(this.refs.content).find("select").material_select();
    $(this.refs.yTickOption).on("change", e => this.setState({yTickOption: e.target.value}));
    $(this.refs.timeAdjustmentOption).on("change", e => this.setState({timeAdjustmentOption: e.target.value}));
    $(this.refs.yAxisVisibility).on("change", e => this.setState({yAxisVisibility: e.target.value}));
  }

  componentDidUpdate() {
    $(this.refs.content).find("select").material_select();
  }

  getInitialMargin(widget) {
    if (widget.metaData.margins) {
      return widget.metaData.margins;
    } else {
      if (widget.type === WidgetType.TIME_SERIES) {
        return {
          top: 0,
          right: 0,
          bottom: 25,
          left: 60
        }
      }

      if (widget.type === WidgetType.TIME_SERIES_VERTICAL) {
        return {
          top: 0,
          right: 60,
          bottom: 70,
          left: 0
        }
      }
    }
  }

  handleChange(e) {
    this.setState({
      format: e.target.value
    });
  }

  handleMarginChange(dir, val) {
    const margins = Object.assign({}, this.state.margins);
    margins[dir] = parseInt(val);
    this.setState({margins});
  }

  confirm() {
    this.refs.modal.hide();
    WidgetService.updateWidgetMetaData(this.props.widget.id, {
      timeTickFormat: this.state.format,
      margins: this.state.margins,
      ticks: this.state.ticks,
      alignLegend: this.state.alignLegend,
      yTickOption: this.state.yTickOption,
      yTickOptionValue: this.state.yTickOptionValue,
      timeAdjustmentOption: this.state.timeAdjustmentOption,
      timeAdjustmentOptionValue: this.state.timeAdjustmentOptionValue,
      yAxisVisibility: this.state.yAxisVisibility,
      updateInterval: this.state.updateInterval,
      maxRepeatDuration: this.state.maxRepeatDuration
    });
    const widget = WidgetService.getWidget(this.props.widget.id);

    // Updating config will reset the chart and user will lose the current view data
    // Stores the end point of the current view data and restores data using this value
    // WidgetService.setPreviousDataPoint(this.props.widget.id);

    this.publish(InternalEvent.Dashboard.UPDATE_DASHBOARD_STATE);
    this.publish(InternalEvent.Dashboard.UPDATE_TIME_TICK_FORMAT, this.props.widget.id);
    this.publish(InternalEvent.Dashboard.CHART_RESET, widget);
  }

  renderMargins() {
    if (this.props.widget.type === WidgetType.TIME_SERIES) {
      return <div className={styles.wrapper}>
        <div className={styles.margin}>
          <div>Top</div>
          <input type="number" value={this.state.margins.top} step="1"
                 onChange={e => this.handleMarginChange("top", e.target.value)}/>
        </div>
        <div className={styles.margin}>
          <div>Right</div>
          <input type="number" value={this.state.margins.right} step="1"
                 onChange={e => this.handleMarginChange("right", e.target.value)}/>
        </div>
        <div className={styles.margin}>
          <div>Bottom</div>
          <input type="number" value={this.state.margins.bottom} step="1"
                 onChange={e => this.handleMarginChange("bottom", e.target.value)}/>
        </div>
        <div className={styles.margin}>
          <div>Left</div>
          <input type="number" value={this.state.margins.left} step="1"
                 onChange={e => this.handleMarginChange("left", e.target.value)}/>
        </div>
      </div>;
    } else {
      return <div className={styles.wrapper}>
        <div className={styles.margin}>
          <div>Top</div>
          <input type="number" value={this.state.margins.right} step="1"
                 onChange={e => this.handleMarginChange("right", e.target.value)}/>
        </div>
        <div className={styles.margin}>
          <div>Right</div>
          <input type="number" value={this.state.margins.bottom} step="1"
                 onChange={e => this.handleMarginChange("bottom", e.target.value)}/>
        </div>
        <div className={styles.margin}>
          <div>Bottom</div>
          <input type="number" value={this.state.margins.left} step="1"
                 onChange={e => this.handleMarginChange("left", e.target.value)}/>
        </div>
        <div className={styles.margin}>
          <div>Left</div>
          <input type="number" value={this.state.margins.top} step="1"
                 onChange={e => this.handleMarginChange("top", e.target.value)}/>
        </div>
      </div>;
    }
  }

  show() {
    this.refs.modal.show();
  }

  render() {
    return (
      <Modal ref="modal" width={500} confirm={this.confirm}>
        <h5>Time series widget configurations</h5>
        <div className={styles.content} ref="content">
          <div className={styles.title}>Format</div>
          <div className={styles.wrapper}>
            <input className={styles.tickFormatInput} type="text" value={this.state.format} name="format"
                   onChange={this.handleChange}/>
          </div>
          <div className={styles.title} style={{marginBottom: "5px"}}>Margins</div>
          {this.renderMargins()}
          <div style={{display: "flex", marginTop: "15px"}}>
            <div>
              <div className={styles.title}>X-axis Tick Interval</div>
              <div className={styles.wrapper}>
                <input className={styles.tickFormatInput} type="text" value={this.state.ticks} name="ticks"
                       onChange={e => this.setState({ticks: e.target.value})} style={{width: "100px"}}/>

              </div>
            </div>
            {/*<div style={{marginLeft: "15px"}}>*/}
              {/*<div className={styles.title}>Update interval(seconds)</div>*/}
              {/*<div className={styles.wrapper}>*/}
                {/*<input className={styles.tickFormatInput} type="number" min="0" step="1"*/}
                       {/*value={this.state.updateInterval}*/}
                       {/*name="interval"*/}
                       {/*onChange={e => this.setState({updateInterval: parseInt(e.target.value)})}/>*/}
              {/*</div>*/}
            {/*</div>*/}
          </div>
          <div style={{display: "flex", alignItems: "flex-end"}}>
            <div className="input-field">
              <select value={this.state.yTickOption} ref="yTickOption">
                <option value="increment">Increment value</option>
                <option value="number">Number of ticks</option>
              </select>
              <label>Y-axis Tick Option</label>
            </div>
            <input className={styles.tickFormatInput} type="text" value={this.state.yTickOptionValue} name="ticks"
                   onChange={e => this.setState({yTickOptionValue: e.target.value})}
                   style={{width: "100px", marginLeft: "20px"}}/>
            <div className="input-field" style={{maxWidth: "150px", marginLeft: "20px"}}>
              <select value={this.state.yAxisVisibility} ref="yAxisVisibility">
                <option value="all">All Y-axises</option>
                <option value="left">Left Y-axis</option>
                <option value="right">Right Y-axis</option>
              </select>
              <label>Y-axis Visibility</label>
            </div>
          </div>
          <div style={{display: "flex", alignItems: "flex-end"}}>
            <div className="input-field">
              <select value={this.state.timeAdjustmentOption} ref="timeAdjustmentOption">
                <option value="s">seconds</option>
                <option value="m">minutes</option>
                <option value="h">hours</option>
                <option value="d">days</option>
                <option value="w">weeks</option>
                <option value="M">months</option>
              </select>
              <label>Time Adjustment</label>
            </div>
            <input className={styles.tickFormatInput} type="text" value={this.state.timeAdjustmentOptionValue}
                   name="ticks"
                   onChange={e => this.setState({timeAdjustmentOptionValue: e.target.value})}
                   style={{width: "100px", marginLeft: "20px"}}/>
          </div>
          <div className={styles.title}>Stale Data Time Trigger(minute)</div>
          <div className={styles.wrapper}>
            <input className={styles.tickFormatInput} type="number" value={this.state.maxRepeatDuration} name="format"
                   onChange={e => this.setState({maxRepeatDuration: e.target.value})}/>
          </div>
          <div className={styles.wrapper}>
            <CheckBox value={this.state.alignLegend} text="Align Legends"
                      onChange={val => this.setState({alignLegend: val})}/>
          </div>

        </div>
      </Modal>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/timeseries-chart/time-tick-formatter/timeSeriesChartCongiguration.jsx